import { TextField, TextFieldProps } from "@mui/material";
import { DatePicker, DatePickerProps, LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import deLocale from "date-fns/locale/de";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import nlLocale from "date-fns/locale/nl";
import { Controller, useFormContext } from "react-hook-form";

type IProps<T> = {
	name: keyof T;
	locale?: "fr" | "nl" | "de" | "en";
	minDate?: Date;
	maxDate?: Date;
};

type Props<T> = IProps<T> & Partial<DatePickerProps<Date, Date>> & TextFieldProps;

const localeMap = {
	en: enLocale,
	fr: frLocale,
	de: deLocale,
	nl: nlLocale,
};

export default function RHFDatePicker<T>({ name, locale = "nl", minDate, maxDate, ...other }: Props<T>) {
	const { control, setValue } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field, fieldState: { error } }) => (
				<LocalizationProvider adapterLocale={localeMap[locale]} dateAdapter={AdapterDateFns}>
					<DatePicker
						{...field}
						disabled={other.disabled}
						minDate={minDate}
						maxDate={maxDate}
						onChange={(date: Date | null) =>
							setValue(name, date as any, { shouldDirty: true, shouldValidate: true, shouldTouch: true })
						}
						renderInput={(params: TextFieldProps) => (
							<TextField {...params} {...other} fullWidth error={!!error} helperText={error?.message} />
						)}
					/>
				</LocalizationProvider>
			)}
		/>
	);
}
